import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

const createPaymentTerm = async (data: any): Promise<any> => {
  return await axios.post('/parameters/cond-pag', data)
}

export function useCreatePaymentTerm() {
  const queryClient = useQueryClient()

  return useMutation(createPaymentTerm, {
    onSuccess: () => {
      queryClient.invalidateQueries('referencePaymentTerms')
      toast.success('Condição de pagamento adicionado com sucesso!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível adicionar condição de pagamento!')
    }
  })
}
